import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import {
  getSmarPanelCurrentPortalPageUrl,
  getSmarPanelPortalBaseUrl,
} from '../utils/smarPanelAccessMonitor';
import { buildSmarPanelToolEvaluationUrls } from '../utils/smarPanelToolEvaluationUrls';

export const SMARPANEL_EVALUATION_URL_SCOPE = {
  PAGE: 'page',
  PORTAL: 'portal',
};

function resolveSmarPanelEvaluationPageUrl(scope) {
  if (scope === SMARPANEL_EVALUATION_URL_SCOPE.PORTAL) {
    return getSmarPanelPortalBaseUrl();
  }

  return getSmarPanelCurrentPortalPageUrl();
}

export function useSmarPanelToolEvaluationUrls(
  scope = SMARPANEL_EVALUATION_URL_SCOPE.PAGE
) {
  const location = useLocation();

  return useMemo(() => {
    return buildSmarPanelToolEvaluationUrls(
      resolveSmarPanelEvaluationPageUrl(scope)
    );
  }, [scope, location.pathname, location.search, location.hash]);
}
